(function () {
    'use strict';
    angular.module('Services').factory('PaymentGatewaysTableService', PaymentGatewaysTableService);
    PaymentGatewaysTableService.$inject = [
        'TableLiteFactory',
        'PaymentGatewayService',
        '$q',
        'toastr',
        '$uibModal'
    ];

    function PaymentGatewaysTableService(
        TableLiteFactory,
        PaymentGatewayService,
        $q,
        toastr,
        $uibModal
    ) {
        return function () {
            const tableData = {
                tableName: 'PaymentGateways',
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'ADD PAYMENT GATEWAY',
                        onClick: showAddPaymentGatewayModal
                    }]
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                    tableHeight: '230px',
                    tableMinHeight: '0px',
                },
                headers: [{
                    label: 'App Name',
                    viewName: 'appName'
                }, {
                    label: 'Enabled',
                    viewName: 'paymentGatewayEnabled'
                }, {
                    label: 'Test Mode',
                    viewName: 'testModeEnabled'
                }, {
                    label: 'Actions',
                    viewName: 'action',
                    width: '150px'
                }],
                data: []
            };

            const tableActions = new TableLiteFactory(
                tableData,
                {
                    serviceCallback: PaymentGatewayService.PaymentGateway.getAll,
                    callbackFormat: ['success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.err(err, 'Error');
                    },
                    defaultFilters: angular.extend({
                        size: 20,
                        page: 0,
                        sort: 'id,asc'
                    })
                }
            );

            function buildTableData(data) {
                if (!data) return tableData;
                tableActions.initializeTableData(data);
                angular.forEach(data.content, (item) => {
                    item.appName = item.appId.toUpperCase();
                    item.paymentGatewayEnabled = item.enabled ? 'Yes': 'No';
                    item.testModeEnabled = item.testMode ? 'Yes': 'No';
                    item.action = {
                        type: 'button',
                        buttons: [{
                            text: 'view',
                            class: 'btn btn-primary btn-quirk',
                            action: () => {
                                showAddPaymentGatewayModal(item);
                            }
                        }]
                    };
                    tableData.data.push(item);
                });
            }

            function showAddPaymentGatewayModal(data = null) {
                $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: '/templates/pages/client/modals/payment-gateway-modal.html',
                    controller: 'PaymentGatewayModalController',
                    backdrop: 'static',
                    keyboard: false,
                    size: 'md',
                    controllerAs: 'vm',
                    resolve: {
                        data: () =>{
                            if(data) {
                                return {
                                    id: data.id,
                                    appId: data.appId,
                                    enabled: data.enabled,
                                    testMode: data.testMode,
                                    parameters: data.parameters
                                }
                            }
                            return null;
                        }
                    }
                }).result.then(data => {
                    tableActions.sendRequest({});
                });
            }

            this.tableData = tableData;
        }
    }
})()



// WEBPACK FOOTER //
// ./js/services/tables/clients/PaymentGatewaysTableService.js